const AUTH_RETURN_PATH_KEY = 'recall-auth-return-path';

export function normalizeAuthReturnPath(candidate, fallback = '/operations') {
  if (typeof candidate !== 'string' || !candidate.startsWith('/') || candidate.startsWith('//')) {
    return fallback;
  }

  try {
    const url = new URL(candidate, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

export function saveAuthReturnPath(candidate) {
  sessionStorage.setItem(AUTH_RETURN_PATH_KEY, normalizeAuthReturnPath(candidate));
}

export function consumeAuthReturnPath(fallback = '/operations') {
  const stored = sessionStorage.getItem(AUTH_RETURN_PATH_KEY);
  sessionStorage.removeItem(AUTH_RETURN_PATH_KEY);
  return normalizeAuthReturnPath(stored, fallback);
}
